var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"titulo"},[_vm._v(" Esse parque possui as trilhas: ")]),_vm._l((_vm.trilhasOnParques),function(i,index){return _c('div',{key:index,staticClass:"trilhas-parques"},[_vm._v(" "+_vm._s(i.nome)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }